export const SESSION_KEY_EXT_PROMO_SHOWN = "sidebar.extension-promotion-indicator.shown";
